
export const enum UserSessionUpdateType {
  USER_INFO = 'USER_INFO',
  ACCOUNT_GROUP = 'ACCOUNT_GROUP',
  ACCOUNT = 'ACCOUNT',
  LIMIT_SCHEDULE = 'LIMIT_SCHEDULE',
  TRADER_INFO = 'TRADER_INFO',
}

export type UserSessionUpdate = {
  updateType: string;
  payload: any;
};
